import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../Context/UserContextProvider';
import axios from "../../../../axios/index"
import { useHistory } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"

// Images
import deleteIcon from "../../../../assets/img/DashboardICons/DeleteIcon_Rounded.svg";

export default function TransferConsultantFile({ state }) {
    const { userToken } = useContext(UserContext);
    const history = useHistory()
    const [consultantsList, setConsultantsList] = useState()
    const [invitedPeople, setInvitedPeople] = useState([])
    const [btnLoader, setBtnLoader] = useState(false)

    const handleClick = (id) => {
        const itemSelected = consultantsList?.filter((item) => id === item.id);
        const found = invitedPeople.find(item => item.id == itemSelected[0].id)
        if (found === undefined) {
            setInvitedPeople([itemSelected[0]]);
        }
    };

    const deleteHandler = (e) => {
        const itemFiltered = invitedPeople.filter((item) => item.id != e.target.id);
        setInvitedPeople(itemFiltered);
    }

    useEffect(() => {
        const getData = async () => {
            // props.setIsLoading(true)
            const getApiData = await axios.get(
                "Consultant?Take=1000000000",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const data = getApiData.data.data.data.filter((item) => item.userId !== state.userId)
            setConsultantsList(data)
        }
        getData()
    }, [userToken, state])

    const topItems = invitedPeople?.map((item) => {
        return (
            <div
                className={`d-flex align-items-center px-2 my-2 mx-2 ${styles.invited_people_container}`}
                key={item.id}
            >
                <div className={styles.added_person_text}>
                    <img
                        className={`ms-2 ${styles.user_profile}`}
                        src={`https://backdev.azrmelk.com${item.imageUrl}`}
                        alt="img"
                    />
                    {item.name + " " + item.family}
                </div>
                <img
                    id={item.id}
                    onClick={deleteHandler}
                    className="me-3 pointer"
                    src={deleteIcon}
                    alt="icon"
                />
            </div>
        );
    });

    const bottomItems = consultantsList?.map((item) => {
        return (
            <div
                key={item.id}
                className={`d-flex align-items-center px-3 my-2 mx-2 ${styles.invited_people_container}`}
            >
                <div
                    onClick={() => handleClick(item.id)}
                    id={item.id}
                    className={`pointer ${styles.added_person_text}`}
                    style={{ cursor: "default" }}
                >
                    <img
                        className={`ms-2 ${styles.user_profile}`}
                        src={`https://backdev.azrmelk.com${item.imageUrl}`}
                        alt="img"
                    />
                    {item.name + " " + item.family}
                </div>
            </div>
        );
    });

    return (
        <>

            <ToastContainer
                position="top-right"
                autoClose={9000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2 mx-2" dir="rtl">
                <div className="mt-1 w-100 text-center">
                    <div
                        className={`w-100 d-flex align-items-start justify-content-start flex-column mt-2 pt-3 pe-4 ${styles.consultantslist_container}`}
                    >
                        <div className={`mb-3 ${styles.input_top_title}`}>
                            مشاور انتخاب شده
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
                            {
                                invitedPeople.length > 0
                                    ? (
                                        <div
                                            className={`d-flex align-items-center justify-content-start flex-wrap my-2 py-2 ${styles.added_people_conatiner}`}
                                        >
                                            {topItems}
                                        </div>
                                    )
                                    : null
                            }
                        </div>
                    </div>

                    <div
                        className={`w-100 d-flex align-items-start justify-content-start flex-column mt-2 pt-3 pe-4 ${styles.consultantslist_container}`}
                    >
                        <div className={`mb-3 ${styles.input_top_title}`}>
                            لیست مشاوران
                        </div>

                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
                            {bottomItems}
                        </div>
                    </div>

                    <div className='w-100 align-align-items-center justify-content-center text-start mt-5 mb-3'>
                        {btnLoader ? (
                            <div className={`text-start ${Dstyles.btn_loader_container}`}>
                                <div className={Dstyles.btn_spinner}></div>
                            </div>
                        )
                            : (
                                <button className={styles.send_btn} type="" onClick={submitHandler}>انتقال فایل</button>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )

    function submitHandler() {
        if (invitedPeople.length !== 0) {
            notify("درحال انتقال فایل ها", "success")
        } else {
            notify("!لطفا مشاور را انتخاب کنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            postHandler()
        } if (type === "success-posted") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function postHandler() {
        setBtnLoader(true)
        try {
            var data = {
                transmitterUserId: state.userId,
                receiverUserId: invitedPeople[0].userId
            }

            const apiData = await axios.post(
                "Estate/TransferUserFiles",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            notify("انتقال فایل ها با موفقیت انجام شد", "success-posted")
        } catch (error) {
            notify("خطایی رخ داد", "error")
        } finally {
            setBtnLoader(false)
            history.push('/staff-managment-activity')
        }
    }
}
